export enum ContratosActionsKeysEnum {
  CONTRATOS = 'contratos',
  CONTRATO = 'contrato',
}

export enum ContratosCorreccionPara {
  VENTAS_TECNICO = "VENTAS-TECNICO",
  TECNICO = "TECNICO",
  VENTAS = "VENTAS"
}

export const CONTRATO_MENU_CONSTANTS = [
  {
    title: "Tickets",
    key: "tickets",
    value: 0,
  },
  {
    title: "Tickets Creados",
    key: "tickets_creados",
    value: 1,
  },
  {
    title: "Información Cliente",
    key: "informacion_cliente",
    value: 2,
  },
];